/* Hover swap: when a mouse hovers a tile photo, show the product's second photo, then restore it on leave.
   Reacts to the real pointer (mouse or pen), so it works even when the browser misreports hover support.
   Touch taps are ignored. window.scHoverInit(root) binds tiles added later (Load more). */
(function () {
  var hasPointer = 'PointerEvent' in window;
  function init(root) {
    var links = [];
    if (root.matches && root.matches('.product-image')) links.push(root);
    root.querySelectorAll('.product-image').forEach(function (l) { links.push(l); });
    links.forEach(function (link) {
      if (link.dataset.hoverBound) return;
      link.dataset.hoverBound = '1';
      var img = link.querySelector('img');
      var hoverUrl = link.getAttribute('data-hover-image');
      if (!img || !hoverUrl) return;
      var saved = null;
      var preload = new Image();
      function warm() { if (!preload.src) preload.src = hoverUrl; }
      function enter(event) {
        if (event && event.pointerType && event.pointerType !== 'mouse' && event.pointerType !== 'pen') return;
        if (saved) return;
        warm();
        saved = { src: img.getAttribute('src'), srcset: img.getAttribute('srcset') || '' };
        img.removeAttribute('srcset');
        img.src = hoverUrl;
      }
      function leave() {
        if (!saved) return;
        img.src = saved.src;
        if (saved.srcset) img.setAttribute('srcset', saved.srcset);
        saved = null;
      }
      link.addEventListener(hasPointer ? 'pointerenter' : 'mouseenter', enter);
      link.addEventListener(hasPointer ? 'pointerleave' : 'mouseleave', leave);
      if ('requestIdleCallback' in window) { requestIdleCallback(warm); } else { setTimeout(warm, 1500); }
    });
  }
  window.scHoverInit = init;
  init(document);
})();
